<template>
<div class="daoh2">
<!--    <el-menu default-active="1-4-1" class="el-menu-vertical-demo" :collapse="isCollapse">-->
<!--        <router-link v-for="item1 in item" :key="item1.id" :to="item1.path" >-->
<!--            <el-menu-item :index="item1.id">-->
<!--                <span slot="title">{{item1.label}}</span>-->
<!--            </el-menu-item>-->
<!--        </router-link>-->
<!--    </el-menu>-->
    <div class="ti">
       <transition>
        <keep-alive>
            <router-view></router-view>
        </keep-alive>
       </transition>
    </div>
</div>
</template>
<script>
export default {
  name: 'RepairIndex',
  data () {
    return {
      isCollapse: false,
      item:[],
      items_list1:[
          {
            id:'1010101',
            label: '报事报修',
            icon: 'mdi-home-outline ',
            path:'/Repair/repairs',
            pid:101010,
          },
          {
            id:'1010102',
            label: '暂挂审核',
            icon: 'mdi-home-outline ',
            path:'/Repair/rpending',
            pid:101010,
          },
          {
            id:'1010103',
            label: '预警设置',
            icon: 'mdi-home-outline ',
            path:'/Repair/rwarning',
            pid:101010,
          },
      ],
    }
  },
  //界面没出来前加载
  created() {
    this.$myhttp.get('admin/lavel2?pid=101010',{
      'Content-Type': 'application/json'
      }).then(backdata=>{ // 异步执行成功后
        if(backdata.data != 1){
          this.item = backdata.data;
        }else{
          this.item = this.items_list1;
        }
        // console.log(backdata.data)
      });
    },
}
</script>
<style scoped>
.daoh2{
    display: flex;
    height: 100%;
}
 .el-menu-vertical-demo:not(.el-menu--collapse) {
    width: 100px;
    height: 100%;
  }
  a{
      text-decoration: none;
   }
   .ti{
    height: 100%;
    width: 100%;
    background-color: white;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/App/Repair/Index.vue